import { Tooltip as AntTooltip, TooltipProps } from 'antd';

export type ITooltipProps = TooltipProps;

const Tooltip = ({ children, ...props }: ITooltipProps): JSX.Element => (
  <AntTooltip {...props}>
    <span>{children}</span>
  </AntTooltip>
);

export default Tooltip;
